import React, { useEffect, useState, useCallback } from "react";
import { pageViewStyle } from "../../pageViewStyle/pageViewStyle";
import { FlameIcon } from "../svgIcons";
export const InstrumentSliderNew = ({ title, items, onMarketClick, currentMarketTab, children, renderFlameIcon }) => {
    const [activeMarketIndex, setActiveMarketIndex] = useState(items.findIndex((i) => i.title === currentMarketTab));
    const [view, setView] = useState(pageViewStyle.getView());
    const onViewUpdate = (view) => {
        setView(view);
    };
    useEffect(() => {
        pageViewStyle.subscribe(onViewUpdate);
        return () => {
            pageViewStyle.unsubscribe(onViewUpdate);
        };
    }, [view]);
    const handleMarketClick = useCallback((event) => {
        if (view === "large") {
            event.preventDefault();
            const index = parseInt(event.currentTarget.getAttribute("data-id") ?? "0");
            setActiveMarketIndex(index);
            onMarketClick(items[index].market);
        }
    }, []);
    const handleOnTouchStart = useCallback((event) => {
        if (event.touches.length > 1) {
            const index = parseInt(event.currentTarget.getAttribute("data-id") ?? "0");
            setActiveMarketIndex(index);
        }
        if (view !== "large" && event.touches.length <= 1) {
            const index = parseInt(event.currentTarget.getAttribute("data-id") ?? "0");
            setActiveMarketIndex(index);
            onMarketClick(items[index].market);
        }
    }, []);
    const handleOnTouchMove = useCallback((event) => {
        setActiveMarketIndex(-1);
    }, []);
    return (React.createElement("div", { className: "instrument-slider--new" },
        title && (React.createElement("h2", { className: "instrument-slider--new__title", dangerouslySetInnerHTML: { __html: title } })),
        React.createElement("div", { className: "instrument-slider--new__items" }, items.map((item, i) => (React.createElement("div", { key: `instrument-slider--new-item-${i}`, className: `instrument-slider--new__item  ${activeMarketIndex === i &&
                "instrument-slider--new__highlighted"}`, "data-id": i, onClick: handleMarketClick, onTouchStart: handleOnTouchStart, onTouchMove: handleOnTouchMove },
            React.createElement("div", { className: "instrument-slider--new__item-title" },
                (i === 0 && renderFlameIcon) && React.createElement("div", { className: "price-feed__headCell-icon" }, FlameIcon()),
                item.title))))),
        children));
};
